// src/components/common/footer/SiteFooter.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../../../css/common/footer/SiteFooter.css';

const TACTICART_URL = 'https://www.tacticart.co.jp/';

const SiteFooter = () => (
  <footer className="site-footer" aria-label="サポートリンクとコピーライト">
    <div className="site-footer__links">
      <Link to="/terms" target="_blank" rel="noopener noreferrer">
        利用規約
      </Link>
      <Link to="/privacy" target="_blank" rel="noopener noreferrer">
        プライバシーポリシー
      </Link>
    </div>
    <div className="site-footer__copy">
      2025~ⒸCasticart by{' '}
      <a href={TACTICART_URL} target="_blank" rel="noopener noreferrer">
        Tacticart
      </a>
    </div>
  </footer>
);

export default SiteFooter;
